<script setup>
import {defineProps} from 'vue'
const props = defineProps({
  type: {
    type: String,
    default: '',
  }
})
</script>

<template>
  <div class="lightning_content" :data-type="props.type"></div>
</template>

<style scoped lang="scss">
.lightning_content {
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 26.40625vw;
    height: 20.3515625vw;
    background: transparent url("@/assets/newPc/left_2.png") no-repeat center center;
    background-size: cover;
  }

  &:after {
    content: '';
    position: absolute;
    top: 7.421875vw;
    left: 0;
    width: 18.046875vw;
    height: 13.90625vw;
    background: transparent url("@/assets/newPc/left_1.png") no-repeat center center;
    background-size: cover;
  }

  &[data-type='top-up'] {
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 26.40625vw;
      height: 20.3515625vw;
      background: transparent url("@/assets/newPc/left_2.png") no-repeat center center;
      background-size: cover;
    }

    &:after {
      content: '';
      position: absolute;
      top: 7.421875vw;
      left: 0;
      width: 18.046875vw;
      height: 13.90625vw;
      background: transparent url("@/assets/newPc/topup/left_3.png") no-repeat center center;
      background-size: cover;
    }
  }
}
</style>